import { SignaturePadComponent } from './signature-pad.component';

export default angular
  .module('sfMobile.components.signature-pad', [
    'sfMobile.services.localization',
    'sfMobile.components.signature',
    'sfMobile.components.button-header-close',
  ])
  .component('sfSignaturePad', SignaturePadComponent).name;
